// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export class MangoHubAddress {
    static getAttributeTypeMap() {
        return MangoHubAddress.attributeTypeMap;
    }
}
MangoHubAddress.discriminator = undefined;
MangoHubAddress.attributeTypeMap = [
    {
        "name": "addressTypeDescription",
        "baseName": "addressTypeDescription",
        "type": "string"
    },
    {
        "name": "address1",
        "baseName": "address1",
        "type": "string"
    },
    {
        "name": "address2",
        "baseName": "address2",
        "type": "string"
    },
    {
        "name": "city",
        "baseName": "city",
        "type": "string"
    },
    {
        "name": "state",
        "baseName": "state",
        "type": "string"
    },
    {
        "name": "zip",
        "baseName": "zip",
        "type": "string"
    },
    {
        "name": "geocoding",
        "baseName": "geocoding",
        "type": "string"
    }
];
//# sourceMappingURL=mangoHubAddress.js.map